import React from "react";
import { COLORS } from "shared/consts";
import {IconProps} from './index.tsx';

export const Notifications: React.FC<IconProps> = ({
                                               fill = COLORS.FG.SOFT,
                                               width = 24,
                                               height = 24,
                                               className,
                                           }) => {
    return (
        <svg className={className} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
             width={width} height={height} fill="none">
            <rect id="24 / Action / Notification " width={width} height={height} x="0.000000" y="0.000000"/>
            <path id="Union"
                  d="M17.3788 16.5L16.7683 8.65106C16.5861 6.30819 14.6318 4.5 12.2819 4.5L11.7181 4.5C9.36818 4.5 7.41389 6.30819 7.23167 8.65105L6.6212 16.5L17.3788 16.5ZM5.73619 8.53474L5.11667 16.5L4 16.5L4 18L5 18L6.50453 18L8.12602 18C8.57006 19.7252 10.1362 21 12 21C13.8638 21 15.4299 19.7252 15.874 18L17.4955 18L19 18L20 18L20 16.5L18.8833 16.5L18.2638 8.53474C18.0208 5.41092 15.4151 3 12.2819 3L11.7181 3C8.58487 3 5.97915 5.41092 5.73619 8.53474ZM14.292 18L9.70802 18C10.0938 18.883 10.9748 19.5 12 19.5C13.0252 19.5 13.9062 18.883 14.292 18Z"
                  fill={fill} fillRule="evenodd"/>
        </svg>

    );
};
